import { useQuery } from "react-query";
import {getUser} from "../../../services/api/users";
import {User} from "../utils/types";

export const USER_SINGLE_QUERY_KEY = "Q_USER_SINGLE";

export const useUser = (id: number) => {
    return useQuery<User>([USER_SINGLE_QUERY_KEY, id], () => getUser(id));
};
